export default function ComparisonChecklist() {
  const checklistItems = [
    {
      category: 'Licensing & Credentials',
      items: [
        'Texas Master Electrician license',
        'City of El Paso business permit',
        'General liability insurance',
        'Workers compensation coverage'
      ]
    },
    {
      category: 'Experience & Expertise',
      items: [
        'Years serving El Paso area',
        'Specialty service areas',
        'Commercial and residential work',
        'Emergency service availability'
      ]
    },
    {
      category: 'Quality & Safety',
      items: [
        'Code compliance knowledge',
        'Safety protocols and training',
        'Quality of materials used',
        'Warranty on workmanship'
      ]
    },
    {
      category: 'Pricing & Transparency',
      items: [
        'Free estimates provided',
        'Detailed cost breakdown',
        'No hidden fees policy',
        'Competitive market rates'
      ]
    },
    {
      category: 'Service & Communication',
      items: [
        'Response time for inquiries',
        'Scheduling flexibility',
        'Clear project timelines',
        'Post-service support'
      ]
    },
    {
      category: 'Reputation & Reviews',
      items: [
        'Online ratings and reviews',
        'Better Business Bureau rating',
        'Customer references available',
        'Repeat customer rate'
      ]
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Electrical Contractor Comparison Checklist
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Important factors to consider when evaluating and comparing electrical contractors for your project
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {checklistItems.map((section, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-md"
            >
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center bg-orange-500 text-white rounded-lg">
                  <i className="ri-checkbox-circle-line text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">
                  {section.category}
                </h3>
              </div>
              
              <ul className="space-y-3">
                {section.items.map((item, idx) => (
                  <li 
                    key={idx}
                    className="flex items-start gap-3 text-gray-700"
                  >
                    <i className="ri-check-line text-orange-500 text-lg mt-0.5 flex-shrink-0"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-orange-50 rounded-xl p-8 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Need an Electrician?
          </h3>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
            Get free quotes from multiple licensed electricians in El Paso and compare their services, pricing, and availability
          </p>
          <button className="px-8 py-4 bg-orange-500 text-white rounded-lg font-semibold hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer">
            Get Free Quotes
          </button>
        </div>
      </div>
    </section>
  );
}
